// extracted by mini-css-extract-plugin
export default {"fadeIn":"StringReducer_fadeIn__KkuFg","fade-in":"StringReducer_fade-in__NUnF4"};